/**
 * BrowserContextSanitizer type definition.
 */
/**
 * Context override provided by an entity-driven chat launch (e.g. clicking "Chat" on a project card).
 * When present, the banner displays this entity's context instead of the current page context.
 *
 * Extensible — to support new entity types, add a new optional field here and a corresponding
 * extractor + priority branch in the `currentContext` memo inside `ContextBanner`.
 */
export const ENTITY_CONTEXT_TYPE = 'entity_context' as const;

export type CurrentEntityContext = {
	type: typeof ENTITY_CONTEXT_TYPE;
	url: string;
	name: string;
};

export interface AiFeatureContextOverride {
	entityContext?: { url: string; name: string };
}

export type BrowserContextSanitizer = {
	/**
	 * Checks if a URL is blocklisted and should not be included in browser context.
	 * @param url - The URL to check
	 * @returns True if the URL is blocklisted, false otherwise
	 */
	isBlocklisted: (url: string) => boolean;
};

export type SelectedAgentChangePayload = {
	id: string;
	identityAccountId?: string;
};
